import { defineNuxtPlugin } from '#app/nuxt'
import { LazyColumnSelectorModal, LazyConversationPanel, LazyProductMatchModal, LazyRequestTable, LazySessionExpiredModal, LazyStatsCard, LazyDjBanner, LazyDjBreadCrumb, LazyDjGhostBtn, LazyDjImage, LazyDjImageZoom, LazyDjPagination, LazyDjTooltip, LazyLanguageSwitcher, LazyCustomerInfo, LazyAdminApiTestComponent, LazyApiTestComponent, LazyTooltipExamples, LazyAuthLayout, LazyBlankLayout, LazyDefaultLayout, LazyDjAddProductForm, LazyDjAddToBuyingListButton, LazyDjAddToCartButton, LazyDjAddToQuoteButton, LazyDjAddressSelect, LazyDjAddresses, LazyDjCarousel, LazyDjCategoryCollapsible, LazyDjCollapsibleMenu, LazyDjComment, LazyDjComments, LazyDjContactProfile, LazyDjCurrencySwitcher, LazyDjFaq, LazyDjFeatureItem, LazyDjFilteredLinkItem, LazyDjFooterBottom, LazyDjHeaderBottom, LazyDjHeaderMain, LazyDjIconWithText, LazyDjLangSwitcher, LazyDjMessages, LazyDjOrderActions, LazyDjOrderLinesTable, LazyDjOrderListItem, LazyDjProductCartCard, LazyDjProductDescriptionSection, LazyDjProductFeaturesSection, LazyDjProductQuoteCard, LazyDjProductSearchResult, LazyDjProductSearchResultVariant, LazyDjProductTitleSection, LazyDjProductVariantInfo, LazyDjQuantity, LazyDjReassuranceList, LazyDjReportIncident, LazyDjSearchBar, LazyDjSlideItem, LazyDjSplitHeroSection, LazyDjStep, LazyDjSteps, LazyDjTabs, LazyDjCartMiniProducts, LazyDjCartProducts, LazyDjCartSummary, LazyDjEmailConfig, LazyDjFooter, LazyDjHeader, LazyDjOrderProducts, LazyDjOrderRecap, LazyDjOrderSummary, LazyDjProductPrice, LazyDjQuoteDetail, LazyDjQuoteLineTable, LazyDjWhatsappConfig, LazyDjPageForgetPassword, LazyDjPageGetAccess, LazyDjPageLogin, LazyDjPageResetPassword, LazyDjCustomerAccounts, LazyDjCustomerActions, LazyDjCustomerContact, LazyDjCustomerDetailPage, LazyDjCustomerGroups, LazyDjCustomerOrders, LazyDjCustomerProfile, LazyDjCustomerQuotes, LazyDjCustomerListPage, LazyDjDashbordPage, LazyAddressSelectionModal, LazyDjEmailDetail, LazyDjEmailDetail2, LazyEmailHeader, LazyEmailHeaderCustomer, LazyEmailTable, LazyEmailTabless, LazyEmptyState, LazyFinalValidationModal, LazyProductFilters, LazyProductTableHeader, LazyDjOrderConfirmationPage, LazyDjOrderDetailPage, LazyDjOrderListPage, LazyDjSalesDetailPage, LazyDjCartLayer, LazyDjCheckoutAddressSection, LazyCartButton, LazyDjEmailTableRow, LazyProductItem, LazyProductRecommendations, LazyProductStatus, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["ColumnSelectorModal", LazyColumnSelectorModal],
["ConversationPanel", LazyConversationPanel],
["ProductMatchModal", LazyProductMatchModal],
["RequestTable", LazyRequestTable],
["SessionExpiredModal", LazySessionExpiredModal],
["StatsCard", LazyStatsCard],
["DjBanner", LazyDjBanner],
["DjBreadCrumb", LazyDjBreadCrumb],
["DjGhostBtn", LazyDjGhostBtn],
["DjImage", LazyDjImage],
["DjImageZoom", LazyDjImageZoom],
["DjPagination", LazyDjPagination],
["DjTooltip", LazyDjTooltip],
["LanguageSwitcher", LazyLanguageSwitcher],
["CustomerInfo", LazyCustomerInfo],
["AdminApiTestComponent", LazyAdminApiTestComponent],
["ApiTestComponent", LazyApiTestComponent],
["TooltipExamples", LazyTooltipExamples],
["AuthLayout", LazyAuthLayout],
["BlankLayout", LazyBlankLayout],
["DefaultLayout", LazyDefaultLayout],
["DjAddProductForm", LazyDjAddProductForm],
["DjAddToBuyingListButton", LazyDjAddToBuyingListButton],
["DjAddToCartButton", LazyDjAddToCartButton],
["DjAddToQuoteButton", LazyDjAddToQuoteButton],
["DjAddressSelect", LazyDjAddressSelect],
["DjAddresses", LazyDjAddresses],
["DjCarousel", LazyDjCarousel],
["DjCategoryCollapsible", LazyDjCategoryCollapsible],
["DjCollapsibleMenu", LazyDjCollapsibleMenu],
["DjComment", LazyDjComment],
["DjComments", LazyDjComments],
["DjContactProfile", LazyDjContactProfile],
["DjCurrencySwitcher", LazyDjCurrencySwitcher],
["DjFaq", LazyDjFaq],
["DjFeatureItem", LazyDjFeatureItem],
["DjFilteredLinkItem", LazyDjFilteredLinkItem],
["DjFooterBottom", LazyDjFooterBottom],
["DjHeaderBottom", LazyDjHeaderBottom],
["DjHeaderMain", LazyDjHeaderMain],
["DjIconWithText", LazyDjIconWithText],
["DjLangSwitcher", LazyDjLangSwitcher],
["DjMessages", LazyDjMessages],
["DjOrderActions", LazyDjOrderActions],
["DjOrderLinesTable", LazyDjOrderLinesTable],
["DjOrderListItem", LazyDjOrderListItem],
["DjProductCartCard", LazyDjProductCartCard],
["DjProductDescriptionSection", LazyDjProductDescriptionSection],
["DjProductFeaturesSection", LazyDjProductFeaturesSection],
["DjProductQuoteCard", LazyDjProductQuoteCard],
["DjProductSearchResult", LazyDjProductSearchResult],
["DjProductSearchResultVariant", LazyDjProductSearchResultVariant],
["DjProductTitleSection", LazyDjProductTitleSection],
["DjProductVariantInfo", LazyDjProductVariantInfo],
["DjQuantity", LazyDjQuantity],
["DjReassuranceList", LazyDjReassuranceList],
["DjReportIncident", LazyDjReportIncident],
["DjSearchBar", LazyDjSearchBar],
["DjSlideItem", LazyDjSlideItem],
["DjSplitHeroSection", LazyDjSplitHeroSection],
["DjStep", LazyDjStep],
["DjSteps", LazyDjSteps],
["DjTabs", LazyDjTabs],
["DjCartMiniProducts", LazyDjCartMiniProducts],
["DjCartProducts", LazyDjCartProducts],
["DjCartSummary", LazyDjCartSummary],
["DjEmailConfig", LazyDjEmailConfig],
["DjFooter", LazyDjFooter],
["DjHeader", LazyDjHeader],
["DjOrderProducts", LazyDjOrderProducts],
["DjOrderRecap", LazyDjOrderRecap],
["DjOrderSummary", LazyDjOrderSummary],
["DjProductPrice", LazyDjProductPrice],
["DjQuoteDetail", LazyDjQuoteDetail],
["DjQuoteLineTable", LazyDjQuoteLineTable],
["DjWhatsappConfig", LazyDjWhatsappConfig],
["DjPageForgetPassword", LazyDjPageForgetPassword],
["DjPageGetAccess", LazyDjPageGetAccess],
["DjPageLogin", LazyDjPageLogin],
["DjPageResetPassword", LazyDjPageResetPassword],
["DjCustomerAccounts", LazyDjCustomerAccounts],
["DjCustomerActions", LazyDjCustomerActions],
["DjCustomerContact", LazyDjCustomerContact],
["DjCustomerDetailPage", LazyDjCustomerDetailPage],
["DjCustomerGroups", LazyDjCustomerGroups],
["DjCustomerOrders", LazyDjCustomerOrders],
["DjCustomerProfile", LazyDjCustomerProfile],
["DjCustomerQuotes", LazyDjCustomerQuotes],
["DjCustomerListPage", LazyDjCustomerListPage],
["DjDashbordPage", LazyDjDashbordPage],
["AddressSelectionModal", LazyAddressSelectionModal],
["DjEmailDetail", LazyDjEmailDetail],
["DjEmailDetail2", LazyDjEmailDetail2],
["EmailHeader", LazyEmailHeader],
["EmailHeaderCustomer", LazyEmailHeaderCustomer],
["EmailTable", LazyEmailTable],
["EmailTabless", LazyEmailTabless],
["EmptyState", LazyEmptyState],
["FinalValidationModal", LazyFinalValidationModal],
["ProductFilters", LazyProductFilters],
["ProductTableHeader", LazyProductTableHeader],
["DjOrderConfirmationPage", LazyDjOrderConfirmationPage],
["DjOrderDetailPage", LazyDjOrderDetailPage],
["DjOrderListPage", LazyDjOrderListPage],
["DjSalesDetailPage", LazyDjSalesDetailPage],
["DjCartLayer", LazyDjCartLayer],
["DjCheckoutAddressSection", LazyDjCheckoutAddressSection],
["CartButton", LazyCartButton],
["DjEmailTableRow", LazyDjEmailTableRow],
["ProductItem", LazyProductItem],
["ProductRecommendations", LazyProductRecommendations],
["ProductStatus", LazyProductStatus],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
